import Link from "next/link";
import React, { useEffect, useState } from "react";
import { news_data } from "../../data/news_data";
import Meta from "../../components/Meta";
import CommentModal from "../modal/commentsModal";
import { useDispatch, useSelector } from "react-redux";
import { commentModalShow } from "../../redux/counterSlice";
import Post_item, { baseURL } from "./post_item";
import Likes from "../likes";
import SingleSocialSlider from "./SingleSocialSlider";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { MdOutlineEdit } from "react-icons/md";
import SharePopup from "../dropdown/SharePopup";
import { MdAdd } from "react-icons/md";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar } from "swiper";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";

const CampaignSocial = () => {
  const [imageModal, setImageModal] = useState(0);
  const [imageModal2, setImageModal2] = useState(0);

  const [showEdit, setShowEdit] = useState(false);
  const [galleryData, setgalleryData] = useState();
  const [albumsData, setAlbumsData] = useState([]);

  const [selectedTab, setSelectedTab] = useState(0);
  const [ShowImagePopup, SetShowImagePopup] = useState(false);
  const requestOptions = {
    method: "GET",
    // redirect: "",
  };

  const getData = async () => {
    try {
      // const response = await fetch(
      //   "https://devapi.impactoverse.com/api/gallery/campaign-posts/6402fe05824a21399e72ff26",
      //   requestOptions
      // );

      // if (!response.ok) {
      //   throw new Error(`HTTP error! Status: ${response.status}`);
      // }

      const data = [
        {
          "image": "1.png",
          "comment": [
            {
              "cmt": "Great photo! The lighting is amazing.",
              "reply": [
                { "reply": "Thank you! I was lucky with the natural light." },
                { "reply": "I appreciate your kind words. It was a magical moment." }
              ]
            },
            {
              "cmt": "Beautiful composition! What camera did you use?",
              "reply": [
                { "reply": "I used a Canon EOS R5 for this shot." },
                { "reply": "Thanks! The camera really delivered on capturing the details." }
              ]
            }
          ]
        },
        {
          "image": "2.png",
          "comment": [
            {
              "cmt": "This scenery is breathtaking!",
              "reply": [
                { "reply": "Nature's wonders never cease to amaze." },
                { "reply": "I'm glad you liked it! The colors were surreal that day." }
              ]
            }
          ]
        },
        {
          "image": "3.png",
          "comment": [
            {
              "cmt": "Love the vibrant colors in this one!",
              "reply": [
                { "reply": "Thank you! I enhanced the colors a bit in post-processing." },
                { "reply": "Your feedback means a lot. I strive for vivid and lively shots." }
              ]
            }
          ]
        }
      ]
      ;
      setgalleryData(data);

      const albums = [
        {
          _id: 1,
          images: ["1.png", "2.png", "3.png", "4.png", "5.png"],
          comment: [
            {
              cmt: "here is comment2",
              reply: [
                { reply: "here is comment " },
                { reply: "here is second reply" },
              ],
            },
          ],
          coverimage: "1.png",
        },
        // {
        //   _id: 2,
        //   images: ['1.png', '2.png', '3.png'],
        //   comment: [{
        //     cmt: 'here is comment2',
        //     reply: [{ reply: 'here is comment reply1' }, { reply: 'here is second reply' }]
        //   }],
        //   coverimage: '1.png'
        // },
        // {
        //   _id: 3,
        //   images: ['1.png', '2.png', '3.png'],
        //   comment: [{
        //     cmt: 'here is comment2',
        //     reply: [{ reply: 'here is comment reply1' }, { reply: 'here is second reply' }]
        //   }],
        //   coverimage: '1.png'
        // },
      ];
      setAlbumsData(albums);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, [Tab]);
  const [showSidebar, setShowSidebar] = useState(false);

  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDropdown = (photoId) => {
    setActiveDropdown((prev) => (prev === photoId ? null : photoId));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".clickable-icon")) {
        setActiveDropdown(null);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isOpenComment, setOpenComment] = useState(false);
  const [isOpenReply, setOpenReply] = useState(0);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  function Drawer({ isOpen, onClose }) {
    return (
      <div
        className={`fixed top-0 left-0 w-full h-full bg-jacarta-800 bg-opacity-50 z-50 ${
          isOpen ? "block" : "hidden"
        }`}
        onClick={onClose}
      >
        <div className="fixed top-0 left-0 h-full bg-jacarta-800 p-5  w-64 shadow-lg">
          <div>
            <h2 id="filters-categories-heading">
              <button
                className="accordion-button relative flex w-full items-center justify-between py-3 text-left font-display text-xl text-jacarta-700 dark:text-white"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#filters-categories"
                aria-expanded="true"
                aria-controls="filters-categories"
              >
                <span>Create Album</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={24}
                  height={24}
                  className="accordion-arrow h-5 w-5 shrink-0 fill-jacarta-700 transition-transform dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                </svg>
              </button>
            </h2>
            <div
              id="filters-categories"
              className="mt-3 collapse show"
              aria-labelledby="filters-categories-heading"
            >
              <div
                id="filters-categories"
                className="mt-3 collapse show"
                aria-labelledby="filters-categories-heading"
              >
                <button
                  type="submit"
                  onClick={(e) => {
                    if (filters?.impactCategory) {
                      onSubmit(e);
                    }
                  }}
                  className="rounded-md bg-accent py-1 px-2 text-xs text-white transition-all hover:bg-accent-dark flex items-center justify-center space-x-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="16"
                    height="16"
                    viewBox="0 0 32 32"
                    fill="white"
                  >
                    <path d="M 16 3 C 12.15625 3 9 6.15625 9 10 L 9 13 L 6 13 L 6 29 L 26 29 L 26 13 L 23 13 L 23 10 C 23 6.15625 19.84375 3 16 3 Z M 16 5 C 18.753906 5 21 7.246094 21 10 L 21 13 L 11 13 L 11 10 C 11 7.246094 13.246094 5 16 5 Z M 8 15 L 24 15 L 24 27 L 8 27 Z"></path>
                  </svg>
                  <span>For me</span>
                </button>

                <div
                  id="filters-collections"
                  className="mt-3 collapse show pt-5"
                  aria-labelledby="filters-collections-heading"
                >
                  <ul className="space-y-6 mb-8">
                    <input
                      type="text"
                      className="w-full rounded-lg border border-jacarta-100 text-jacarta-700 placeholder-jacarta-500 focus:ring-accent dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                      placeholder="Album Name"
                      name="album"
                    />
                  </ul>
                  <button
                    type="submit"
                    className="rounded-full bg-accent w-full py-2 px-4 text-center font-semibold text-white transition-all hover:bg-accent-dark"
                    onClick={(e) => {
                      if (filters?.username) {
                        onSubmit(e);
                      }
                    }}
                  >
                    Upload photos or videos
                  </button>
                </div>
                <div
                  id="filters-impact-categories"
                  className="mt-5 collapse show"
                  aria-labelledby="filters-impact-categories-heading"
                >
                  <div
                    id="filters-impact-categories"
                    className="mt-3 collapse show"
                    aria-labelledby="filters-impact-categories-heading"
                  >
                    {/* <Form /> */}
                    <ul className="space-y-6 mb-8">
                      {/* <CollectionsItem /> */}

                      <select
                        name="nftCategory"
                        className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 mr-8 w-full rounded-lg py-3.5 text-sm dark:text-white"
                      >
                        <option value="">--Impact DOT Category--</option>
                        {/*  {!!nftCategory?.length &&
                          nftCategory.sort().map((v, i) => (
                            <React.Fragment key={i}>
                              <option value={v}>{v}</option>
                            </React.Fragment>
                          ))} */}
                      </select>
                    </ul>
                    <button
                      type="submit"
                      className="rounded-full bg-accent w-full py-3 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark"
                      onClick={(e) => {
                        if (filters?.nftCategory) {
                          onSubmit(e);
                        }
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function SideSection({ isOpen, onClose, comments }) {
    return (
      <div
        className={` w-[250px]   overflow-y-auto max-h-screen lg:overflow-auto lg:sticky    scrollbar-custom   bg-jacarta-800  ${
          isOpen ? "block" : "hidden"
        }`}
        onClick={onClose}
      >
        <div className="fixed h-full overflow-y-auto max-h-screen lg:overflow-auto     scrollbar-custom top-0 left-0 h-full bg-jacarta-800 p-3  w-64 shadow-lg">
          <div className="border-jacarta-100   flex border   transition-shadow hover:shadow-lg dark:border-transparent">
            <figure className="mr-4 shrink-0">
              <Link href={"#"} className="relative block">
                <Image
                  width={48}
                  height={48}
                  src={"/images/Social/1.png"}
                  className="rounded-2lg h-12 w-12"
                />
              </Link>
            </figure>
            <div>
              <Link href={"#"} className="block">
                <span className="font-display text-jacarta-700 hover:text-accent font-semibold dark:text-white ">
                  imran
                </span>
              </Link>
              <span className="dark:text-jacarta-300 text-sm">
                5 Feburary at 12:07pm
              </span>
            </div>

            {/* <div className="absolute top-0 right-0 mt-4 mr-2 rounded-full bg-jacarta-900 p-2 opacity-70 hover:opacity-90">
              <MdOutlineEdit
                onClick={() => { setShowEdit(!showEdit) }}
                className="clickable-icon h-5 w-5 bg-blue-800 !important text-white cursor-pointer"
              />
              {showEdit && (
                <div className="dropdown-menu-end dark:bg-jacarta-800 z-10 min-h-fit mb-6 min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show text-jacarta-500 absolute top-full right-0">
                  <button className="dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white">
                    Download
                  </button>
                  <button className="dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white">
                    Delete
                  </button>
                </div>
              )}
            </div> */}
          </div>

          <div className=" h-[1px] bg-white w-full mt-2 mb-3"></div>

          <div>
            In a serene marshland bathed in the warm hues of a setting sun, a
            lone flamingo stands tall, its slender neck arched gracefully. The
            sky is a canvas of pastel pinks and oranges, reflecting in the calm
            waters below.
          </div>
          {/* <button
            type="submit"
            className="rounded-full block bg-accent  py-1 px-4 text-center font-semibold text-white transition-all hover:bg-accent-dark"

          >
            Edit
          </button> */}
          <div className=" h-[0.5px] bg-white w-full mt-4 "></div>
          <div className=" flex justify-between my-4">
            <div className=" flex gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="24"
                fill="currentColor"
                class="bi bi-hand-thumbs-up"
                viewBox="0 0 16 16"
              >
                <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
              </svg>
              <div>Like</div>
            </div>
            <div
              onClick={() => setOpenComment(!isOpenComment)}
              className=" flex gap-2 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="24"
                fill="currentColor"
                class="bi bi-chat"
                viewBox="0 0 16 16"
              >
                <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
              </svg>
              <div>Comment</div>
            </div>
          </div>
          <div className=" h-[0.5px] bg-white w-full  "></div>

          {isOpenComment && (
            <div>
              <ul className="space-y-6 mb-8 mt-3">
                <input
                  type="text"
                  className="w-full rounded-lg border border-jacarta-100 text-jacarta-700 placeholder-jacarta-500 focus:ring-accent dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                  placeholder="Write a comment..."
                  name="album"
                />
              </ul>
              {comments?.map((comment, index) => (
                <div key={index}>
                  <div className="border-jacarta-100 dark:bg-jacarta-700 py-4 px-1   flex border   transition-shadow hover:shadow-lg dark:border-transparent">
                    <figure className="mr-4 shrink-0">
                      <Link href={"#"} className="relative block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          fill="currentColor"
                          class="bi bi-person-circle"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                          <path
                            fill-rule="evenodd"
                            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                          />
                        </svg>
                      </Link>
                    </figure>
                    <div>
                      <Link href={"#"} className="block">
                        <span className="font-display text-jacarta-700 hover:text-accent font-semibold dark:text-white">
                          Justin
                        </span>
                      </Link>
                      <span className="dark:text-jacarta-300 text-sm">
                        {comment.cmt}
                      </span>
                    </div>
                  </div>
                  <div className=" flex gap-4 mb-4">
                    <div>1 week ago</div>
                    <div>Like</div>
                    <button
                      onClick={() => {
                        isOpenReply > 0
                          ? setOpenReply(0)
                          : setOpenReply(index + 1);
                      }}
                    >
                      Reply
                    </button>
                  </div>
                  {isOpenReply > 0 && (
                    <ul className="space-y-6 mb-8">
                      <input
                        type="text"
                        className="w-full rounded-lg border border-jacarta-100 text-jacarta-700 placeholder-jacarta-500 focus:ring-accent dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                        placeholder="Write a reply..."
                        name="album"
                      />
                    </ul>
                  )}
                  {isOpenReply > 0 &&
                    isOpenReply == index + 1 &&
                    comment.reply.map((value, index) => (
                      <div key={index} className="ml-5 mb-4">
                        <div className="border-jacarta-100   dark:bg-jacarta-700 py-1 px-1  flex border   transition-shadow hover:shadow-lg dark:border-transparent">
                          <figure className="mr-4 shrink-0">
                            <Link href={"#"} className="relative block">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                fill="currentColor"
                                class="bi bi-person-circle"
                                viewBox="0 0 16 16"
                              >
                                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                                <path
                                  fill-rule="evenodd"
                                  d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                                />
                              </svg>
                            </Link>
                          </figure>
                          <div>
                            <Link href={"#"} className="block">
                              <span className="font-display text-jacarta-700 hover:text-accent font-semibold dark:text-white">
                                aunnaglobal
                              </span>
                            </Link>
                            <span className="dark:text-jacarta-300 text-sm">
                              {value.reply}
                            </span>
                          </div>
                        </div>
                        <div className=" flex gap-4 mt-2">
                          {" "}
                          <div>1 hr ago</div>
                          <div>Like</div>
                        </div>
                      </div>
                    ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  console.log(galleryData);

  return (
    <>
      <Tabs
        // className="p-3"
        selectedIndex={selectedTab}
        onSelect={(index) => setSelectedTab(index)}
      >
        <TabList className="flex p-4">
          <Tab
            className={`text-lg py-2 px-4 cursor-pointer font-display text-base font-medium ${
              selectedTab === 0
                ? "border-b-2 border-gray-400"
                : "border-b-2 border-transparent hover:border-green-500 focus:border-green-500"
            }`}
          >
            Photos
          </Tab>

          <Tab
            className={`text-lg py-2 px-4 cursor-pointer font-display text-base font-medium ${
              selectedTab === 1
                ? "border-b-2 border-gray-400"
                : "border-b-2 border-transparent hover:border-green-500 hover:text-green-500 focus:border-green-500 focus:text-green-500"
            }`}
          >
            Albums
          </Tab>
        </TabList>
        <TabPanel className={`py-3 px-4 ${galleryData?.length > 0}`}>
          <div className="flex flex-wrap-reverse gap-4 p-4">
            {galleryData?.map((photo, index) => (
              <div key={index} className="relative">
                <div
                  className={`flex flex-wrap ${
                    index === galleryData.length - 1
                      ? "justify-center"
                      : "justify-start"
                  }`}
                >
                  {/* {photo.assets.map((asset, index) => ( */}
                  <div className="relative">
                    <span
                      className=" cursor-pointer"
                      onClick={() => setImageModal(index + 1)}
                    >
                      <Image
                        width={200}
                        height={200}
                        src={`/images/Social/${photo.image}`}
                        alt={`Image `}
                        className="cards object-cover mt-2 mb-2 bg-blue-800 border rounded-md"
                      />
                    </span>
                    <figure className="mb-8 md:w-2/5 md:flex-shrink-0 md:flex-grow-0 md:basis-auto lg:w-1/2 w-full">
                      {/* <!-- Modal --> */}
                      <div
                        className={
                          imageModal ? "modal fade show block" : "modal fade"
                        }
                      >
                        <div className="modal-dialog !my-0 flex h-full max-w-4xl items-center justify-center">
                          <Image
                            width={200}
                            height={200}
                            src={`/images/Social/${
                              galleryData[imageModal - 1]?.image
                            }`}
                            alt={"0"}
                            className="h-full object-cover w-full rounded-2xl"
                          />
                        </div>

                        <button
                          type="button"
                          className="btn-close absolute top-6 right-6 z-50"
                          onClick={() => setImageModal(0)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-6 w-6 fill-white"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                          </svg>
                        </button>
                        <SideSection
                          isOpen={true}
                          comments={galleryData[imageModal - 1]?.comment}
                        />
                      </div>

                      {/* <!-- end modal --> */}
                    </figure>

                    {/* <div className="absolute top-0 right-0 mt-4 mr-2 rounded-full bg-jacarta-900 p-2 opacity-70 hover:opacity-90">
                      <MdOutlineEdit
                        onClick={() => handleDropdown(photo._id + '-' + index)}
                        className="clickable-icon h-5 w-5 bg-blue-800 !important text-white cursor-pointer"
                      />
                      {activeDropdown === photo._id + '-' + index && (
                        <div className="dropdown-menu-end dark:bg-jacarta-800 z-10 min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show text-jacarta-500 absolute top-full right-0">
                          <button className="dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white">
                            Download
                          </button>
                          <button className="dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white">
                            Delete
                          </button>
                        </div>
                      )}
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </TabPanel>

        <TabPanel className={`${galleryData?.posts?.length > 0}  mt-0 px-4`}>
          <div className="flex flex-wrap  justify-center sm:justify-start">
            {/* <div
              style={{ width: "200px", height: "200px", textAlign: "center" }}
              className="cards mt-2 mb-2 mr-4 bg-jacarta-400 border rounded-md flex-shrink-0"
              onClick={toggleDrawer}
            >
              <div className="w-full h-full flex flex-col items-center justify-center">
                <MdAdd
                  onClick={toggleDrawer}
                  style={{ width: "25px", height: "25px", color: "black" }}
                />
                <p
                  style={{ color: "black", textAlign: "start" }}
                  className="font-medium pt-1 pb-2"
                >
                  {" "}
                  Album
                </p>
              </div>
            </div> */}
            {albumsData?.map((photo, index) => (
              <React.Fragment key={index}>
                {
                  <div className="relative mr-4" key={index}>
                    <div
                      onClick={() => setImageModal2(index + 1)}
                      className=" cursor-pointer"
                    >
                      <Image
                        width={200}
                        height={200}
                        src={`/images/Social/${photo.coverimage}`}
                        alt={`Image `}
                        className="cards object-cover mt-2 mb-2 bg-blue-800 border rounded-md"
                      />
                    </div>
                    <div className="absolute top-0 right-0 mt-4 mr-2 rounded-full bg-jacarta-900 p-2 opacity-70 hover:opacity-90">
                      <MdOutlineEdit
                        onClick={() => handleDropdown(photo._id + "-" + index)}
                        className="clickable-icon h-5 w-5 bg-blue-800 !important text-white cursor-pointer"
                      />
                      {activeDropdown === photo._id + "-" + index && (
                        <div className="dropdown-menu-end dark:bg-jacarta-800 z-10 min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show text-jacarta-500 absolute top-full right-0">
                          <button className="dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white">
                            Edit Album
                          </button>
                          <button className="dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white">
                            Download Album
                          </button>
                          <button className="dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white">
                            Edit Album
                          </button>
                          <button className="dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-50 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white">
                            Delete Album
                          </button>
                        </div>
                      )}
                    </div>

                    <h3 className="font-display text-jacarta-700 text-sm dark:text-white uppercase">
                      Album{index}
                    </h3>
                    <figure className="mb-8   md:flex-shrink-0 md:flex-grow-0 md:basis-auto justify-center items-center bg-red ">
                      {/* <!-- Modal --> */}
                      <div
                        className={
                          imageModal2
                            ? "modal fade show flex "
                            : "modal fade hidden"
                        }
                      >
                        <div className=" flex h-full max-w-4xl justify-start items-center ml-[350px]">
                          {/* <Image
                            width={582}
                            height={722}
                            src={`/images/Social/${photo.images[1]}`}
                            alt={'0'}
                            className="h-full object-cover w-full rounded-2xl"
                          /> */}
                          <Swiper
                            modules={[Navigation, Pagination, Scrollbar]}
                            spaceBetween={30}
                            slidesPerView="auto"
                            loop={true}
                            breakpoints={{
                              240: {
                                slidesPerView: 1,
                              },
                            }}
                            navigation={{
                              nextEl: ".bids-swiper-button-next",
                              prevEl: ".bids-swiper-button-prev",
                            }}
                            className="card-slider-4-columns !py-5"
                          >
                            {photo.images.map((image, index) => (
                              <SwiperSlide className="text-white" key={index}>
                                <article>
                                  <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg text-jacarta-500">
                                    <figure>
                                      <img
                                        src={`/images/Social/${image}`}
                                        alt={"alt"}
                                        height={230}
                                        width={230}
                                        className="rounded-[0.625rem] w-full lg:h-[230px] object-cover"
                                        loading="lazy"
                                      />
                                    </figure>
                                  </div>
                                </article>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </div>
                        <div className="z-50 group ml-[300px] bids-swiper-button-prev swiper-button-prev shadow-white-volume   flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-jacarta-700 text-xl sm:!-left-6 after:hidden">
                          <MdKeyboardArrowLeft />
                        </div>
                        <div className="z-50 mr-[200px] group bids-swiper-button-next swiper-button-next shadow-white-volume  flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-jacarta-700 text-xl sm:!-right-6 after:hidden">
                          <MdKeyboardArrowRight />
                        </div>
                        <button
                          type="button"
                          className="btn-close absolute top-6 right-6 z-50"
                          onClick={() => setImageModal2(0)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-6 w-6 fill-white"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                          </svg>
                        </button>
                        <SideSection
                          isOpen={true}
                          comments={albumsData[imageModal2 - 1]?.comment}
                        />
                      </div>

                      {/* <!-- end modal --> */}
                    </figure>
                  </div>
                }
              </React.Fragment>
            ))}
          </div>

          <Drawer isOpen={isDrawerOpen} onClose={toggleDrawer} />
        </TabPanel>
      </Tabs>
    </>
  );
};

export default CampaignSocial;
